import React from 'react';
import { Grid, Button, Dropdown, Form } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';

const statusOptions = [
  { key: 'active', text: 'Active', value: 1 },
  { key: 'inactive', text: 'Inactive', value: 0 }
];

const CreateProductForm = ({
  onChangeOfName,
  setManufacturerId,
  onChangeOfStatus,
  mfOptions,
  productName,
  handleSubmit,
  submitting,
  dropdownLoading
}) => (
  <Grid centered style={{ marginTop: '0px', padding: '10vh' }}>
    <Helmet>
      <title>Create New Product</title>
    </Helmet>
    <Grid.Row centered>
      <Grid.Column width={4}>
        <h2
          style={{
            fontWeight: 400,
            marginBottom: '1em',
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Create New Product
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={8}>
        <Form>
          <Form.Field required>
            <label>Name of Product</label>
            <input
              disabled={submitting}
              value={productName}
              onChange={onChangeOfName}
              placeholder="Example: Poha"
            />
          </Form.Field>
          <Form.Field required>
            <label>Select Manufacturer</label>
            <Dropdown
              placeholder="Select Manufacturer"
              disabled={dropdownLoading || submitting}
              onChange={setManufacturerId}
              selection
              search
              options={mfOptions || []}
            />
          </Form.Field>
          <Form.Field required>
            <label>Status</label>
            <Dropdown
              disabled={submitting}
              onChange={onChangeOfStatus}
              selection
              options={statusOptions}
            />
          </Form.Field>
          <Form.Field />
          <Button
            loading={submitting}
            onClick={handleSubmit}
            basic
            color="blue"
            style={{ float: 'right' }}
          >
            Add Product
          </Button>
        </Form>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default CreateProductForm;



// WEBPACK FOOTER //
// ./src/Modules/CreateNewProduct/component.jsx